/*
 *  Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { BudgetTab } from "~/components/Budgets";
import { useOrgUnitBudget } from "./hooks";

type Props = {
  orgUnitId: string;
};

export function OrgUnitBudgetTab({ orgUnitId }: Props) {
  const {
    budget,
    forecast,
    sumOfChildrenBudgets,
    spends,
    createOrgUnitBudget,
    updateOrgUnitBudget,
    loading,
    error,
    year,
    setYear,
    getGeneratedBudget,
    isBudgetGenerated,
    reset,
  } = useOrgUnitBudget(orgUnitId);

  return (
    <BudgetTab
      budget={budget}
      forecast={forecast}
      childrenBudget={sumOfChildrenBudgets}
      spends={spends}
      year={year}
      isBudgetGenerated={isBudgetGenerated}
      loading={loading}
      error={error}
      warningCaption="The total environmental and sub-budgets are greater than the Organizational Unit budget."
      onSetYear={setYear}
      onCreateBudget={createOrgUnitBudget}
      onEditBudget={updateOrgUnitBudget}
      onGetGeneratedBudget={getGeneratedBudget}
      onBudgetReset={reset}
    />
  );
}
